import React from "react";
import PushMenu from 'react-push-menu';
import { FaChevronRight, FaChevronLeft} from 'react-icons/fa';

class SideBar extends React.Component{

    render(){
            if(this.props.navigation.loaded === false ){
                return <div/>
            }
            return (
              <PushMenu
                backIcon={<FaChevronLeft/>}
                expanderComponent={FaChevronRight}
                nodes={this.props.navigation.menu}
                type={'cover'}
                onMenuOpen={(menu) => {
                    // do something

                }}
                propMap={{url: 'link'}}>

              </PushMenu>
            );
    }
}


export default SideBar;



// WEBPACK FOOTER //
// ./src/components/navigation/SideBar.js